import { Link } from 'react-router';
import { openAuthenticatedFile } from '../../api/client.js';
import { Alert, PageHeader, datum, pct, useLoad } from '../shared/ui.js';

interface Row {
  accountId: string;
  name: string;
  accountNumber: string;
  versionId: string | null;
  baseDiscountPercent: number | null;
  validFrom: string | null;
  validTo: string | null;
  deviationCount: number;
  status: 'active' | 'missing';
}

/** Interne Uebersicht ueber alle Kundenkonditionen, mit CSV-Export. */
export function ConditionsOverviewPage(): React.JSX.Element {
  const { data, error } = useLoad<{ items: Row[] }>('/api/admin/conditions/overview');
  return (
    <>
      <PageHeader
        title="Konditionen"
        lead="Alle aktiven Kunden mit ihrer heute gueltigen Kondition."
        actions={
          <button
            type="button"
            onClick={() => void openAuthenticatedFile('/api/admin/conditions/export.csv')}
          >
            Export als CSV
          </button>
        }
      />
      <Alert text={error} />
      {data !== null && (
        <div className="card">
          <div className="table-scroll">
            <table>
              <thead>
                <tr>
                  <th>Kunde</th>
                  <th>Kundennummer</th>
                  <th className="num">Grundrabatt</th>
                  <th className="num">Abweichungen</th>
                  <th>Gueltig ab</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {data.items.map((r) => (
                  <tr key={r.accountId}>
                    <td>
                      <Link to={`/admin/kunden/${r.accountId}/konditionen`}>
                        {r.name}
                      </Link>
                    </td>
                    <td>
                      <code>{r.accountNumber}</code>
                    </td>
                    <td className="num">
                      {r.status === 'missing' ? '–' : pct(r.baseDiscountPercent)}
                    </td>
                    <td className="num">{r.deviationCount}</td>
                    <td>{datum(r.validFrom)}</td>
                    <td>
                      {r.status === 'missing' ? (
                        <span className="pill pill-warn">noch nicht eingerichtet</span>
                      ) : (
                        <span className="pill pill-ok">gueltig</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );
}
